import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthData, CpExamination, DeleteExaminations, IdReportItem } from '@se/models';
import { Observable } from 'rxjs';
import { ServerRootService } from '../../../utils/routing/serverroot.service';
import { ExaminationsFilter } from '../../report-workflow-exam.service';

/** Il servizio deve contenere tutte le chiamate ai metodi rest nel controller ReportCore!
 * Ogni metodo non deve avere logica ma solo effettuare la chiamata.
 * il tipo di ritorno deve essere sempre un Observable
 */
export abstract class ReportCoreBaseService extends ServerRootService {
    protected readonly httpClient = inject(HttpClient);

    /** Cancella più examinations in stato R. */
    deleteReportedExaminations(data: DeleteExaminations, authData?: AuthData): Observable<boolean> {
        return this.httpClient.post<boolean>(
            this.getServerRoot() + '/ReportCore/DeleteReportedExaminations',
            data,
            this.buildOptions(authData),
        );
    }

    disconnectReport(disconnectReport: IdReportItem) {
        return this.httpClient.post(
            this.getServerRoot() + '/ReportCore/DisconnectReport',
            disconnectReport,
            this.buildOptions(),
        );
    }

    getExaminationsToAdd(options: ExaminationsFilter): Observable<CpExamination[]> {
        return this.httpClient.post<CpExamination[]>(
            this.getServerRoot() + '/ReportCore/GetExaminationsToAdd',
            options,
            this.buildOptions(),
        );
    }

    getExaminationsToRemove(idReport: string): Observable<CpExamination[]> {
        return this.httpClient.post<CpExamination[]>(
            this.getServerRoot() + '/ReportCore/GetReportExaminationsToRemove',
            { idReport },
            this.buildOptions(),
        );
    }
}

